<template>
  <div>
    <UtiReportView></UtiReportView>
  </div>
</template>

<script>
import { defineAsyncComponent } from "vue";
const UtiReportView = defineAsyncComponent(() =>
  import("@/components/cases/SupplementaryReportView")
);
export default {
  components: {
    UtiReportView,
  },
};
</script>

<style></style>
